<template>
    <b-list-group>
        <b-list-group-item>
            <div class="d-flex justify-content-between">
                <span>Кол-во заказов:</span>
                <span>{{orders.length}}</span>
            </div>
        </b-list-group-item>
        <!--<b-list-group-item>-->
        <!--<h6 class="d-flex justify-content-between">-->
        <!--<span>Кол-во заказов:</span>-->
        <!--<span>N руб</span>-->
        <!--</h6>-->
        <!--</b-list-group-item>-->
        <b-list-group-item >
            <div class="d-flex justify-content-between">
                <span>Наличные:</span>
                <span>{{cashStats()}} руб</span>
            </div>
        </b-list-group-item>
        <b-list-group-item>
            <div class="d-flex justify-content-between">
                <span>Безналичные:</span>
                <span>{{cardInPlaceStats()}} руб</span>
            </div>
        </b-list-group-item>
        <b-list-group-item>
            <div class="d-flex justify-content-between">
                <span>Оплата онлайн:</span>
                <span>{{cardOnlineStats()}} руб</span>
            </div>
        </b-list-group-item>
        <b-list-group-item>
            <div class="d-flex justify-content-between">
                <span>Аванс:</span>
                <span>{{sberbankStats()}} руб</span>
            </div>
        </b-list-group-item>
        <b-list-group-item>
            <div class="d-flex justify-content-between">
                <span>Платежная ссылка:</span>
                <span>{{paymentLinkStats()}} руб</span>
            </div>
        </b-list-group-item>
        <b-list-group-item>
            <div class="d-flex justify-content-between">
                <span>Итого:</span>
                <span>{{allOrdersSum()}} руб</span>
            </div>
        </b-list-group-item>
        <b-list-group-item></b-list-group-item>
        <b-list-group-item class="salary-color">
            <div v-b-toggle.HistoryOrders class="d-flex justify-content-between">
                <span>&darr; Зарплата за смену: </span>
                <span>{{deliveryPriceStats()}} руб &darr;</span>
            </div>
        </b-list-group-item>
        <b-collapse id="HistoryOrders">
            <b-list-group>
                <b-list-group-item v-for="order in orders"
                                   :key="order.id">
                    <div :class="orderClass(order)">
                        <span>Заказ №{{order.idDay}}:</span>
                        <span>{{sumPriceStats(order)}} руб. | {{getOrderSalary(order)}} руб. </span>
                    </div>
                </b-list-group-item>
            </b-list-group>
        </b-collapse>
        <b-list-group-item>
            <div class="d-flex justify-content-between">
                <span>Итого к сдаче: </span>
                <span>{{oddMoney()}} руб</span>
            </div>
        </b-list-group-item>
    </b-list-group>
</template>

<script>
import {
  STATUS_ORDER
} from '@/constants/keywords'
export default {
  name: 'CourierStatDisplay',
  props: {
    orders: {
      type: Array,
      required: true
    }
  },
  data: function () {
    return {
    }
  },
  methods: {
    orderClass (order) {
      let courieInTime = this.courieInTime(order)
      let classes = 'courier-individual-order d-flex justify-content-between'
      if (courieInTime && typeof courieInTime.in_time !== 'undefined') {
        if (courieInTime.in_time === true) {
          classes += ' in-time'
        } else if (courieInTime.in_time === false) {
          classes += ' not-in-time'
        }
      }
      return classes
    },
    sumPriceStats (order) {
      let sumPrice = 0
      sumPrice += parseInt(order.paymentInfo.cash)
      sumPrice += parseInt(order.paymentInfo.cardInPlace)
      sumPrice += parseInt(order.paymentInfo.cardOnline)
      sumPrice += parseInt(order.paymentInfo.sberbank)
      sumPrice += parseInt(order.paymentInfo.paymentLink)
      return sumPrice
    },
    cashStats () {
      let cash = this.orders.reduce((sum, val) => {
        return sum + parseInt(val.paymentInfo.cash)
      }, 0)
      return cash
    },
    cardInPlaceStats () {
      let cardInPlace = 0
      this.orders.forEach(ord => {
        cardInPlace += parseInt(ord.paymentInfo.cardInPlace)
      })
      return cardInPlace
    },
    cardOnlineStats () {
      let cardOnline = 0
      this.orders.forEach(pay => {
        cardOnline += parseInt(pay.paymentInfo.cardOnline)
      })
      return cardOnline
    },
    sberbankStats () {
      let sum = 0
      this.orders.forEach(pay => {
        sum += parseInt(pay.paymentInfo.sberbank)
      })
      return sum
    },
    paymentLinkStats () {
      let sum = 0
      this.orders.forEach(pay => {
        sum += parseInt(pay.paymentInfo.paymentLink)
      })
      return sum
    },
    deliveryPriceStats () {
      let deliveryPriceStat = 0
      this.orders.forEach(pay => {
        // console.log('pay', pay)
        let getInTimeSalary = this.getInTimeSalary(pay)
        deliveryPriceStat += parseInt(pay.priceDelivery ? pay.priceDelivery : 0) + getInTimeSalary
      })
      return deliveryPriceStat
    },
    oddMoney () {
      let sumOddMoney = 0
      sumOddMoney = this.cashStats() - this.deliveryPriceStats()
      return sumOddMoney
    },
    allOrdersSum () {
      return this.orders.reduce((val, order) => {
        return val + parseInt(order.price)
      }, 0)
    },
    getInTimeTextInfo (order) {
      let courierInTime = this.courieInTime(order)
      if (courierInTime) return '(+' + courierInTime.sum + ' руб.)'
      return ''
    },
    getInTimeSalary (order) {
      let courierInTime = this.courieInTime(order)
      // console.log(order, courierInTime)
      return parseInt(courierInTime ? courierInTime.sum : 0)
    },
    getOrderSalary (order) {
      return parseInt(order.priceDelivery ? order.priceDelivery : 0) + parseInt(this.getInTimeSalary(order))
    },
    getDeliveryTime (order) {
      let timeInMinutes = null
      let statuses = order.statuses.nodes
      if (statuses.length !== 0) {
        let inDeliveryTime = null
        let passedTime = null

        let inDeliveryStage = statuses.find(status => status.stage.keyword === STATUS_ORDER.COOKING)
        let passedStage = statuses.find(status => status.stage.keyword === STATUS_ORDER.PASSED)

        if (inDeliveryStage && passedStage) {
          inDeliveryTime = this.$moment(inDeliveryStage.time)
          passedTime = this.$moment(passedStage.time)
          timeInMinutes = passedTime.diff(inDeliveryTime, 'minutes')
        }
      }
      return timeInMinutes
    },
    courieInTime (order) {
      let timeInMinutes = this.getDeliveryTime(order)
      if (order.delivery && order.delivery.restpoint && order.delivery.restpoint.targetTimeDeliveryIn && order.delivery.restpoint.targetSumDeliveryIn && timeInMinutes <= order.delivery.restpoint.targetTimeDeliveryIn && order.coordsClosed !== null) {
        return {
          in_time: true,
          sum: order.delivery.restpoint.targetSumDeliveryIn
        }
      } else if (order.delivery && order.delivery.restpoint && order.delivery.restpoint.targetSumDeliveryOut) {
        return {
          in_time: false,
          sum: order.delivery.restpoint.targetSumDeliveryOut
        }
      }
      return null
    }
  }
}
</script>

<style scoped>
  .courier-individual-order.in-time {
    background-color: rgb(226, 255, 230);
  }
  .courier-individual-order.not-in-time {
    background-color: rgb(255, 204, 204);
  }
</style>



// WEBPACK FOOTER //
// src/components/CourierStatDisplay.vue